export default __webpack_public_path__ + "static/media/icon-delete.da90a9bc.svg";